import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, TemplateRef } from '@angular/core';

@Component({
  selector: 'lib-card',
  imports: [TranslateModule, CommonModule],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  title = input<string | undefined>('');
  description = input<string | undefined>('');
  headerTemplate = input<TemplateRef<unknown> | null>(null);
  size = input<'fullWidth' | 'large' | 'small' | 'extra-small'>('fullWidth');
  innerCard = input<boolean>(false);
  variant = input<'primary' | 'secondary' | 'tertiary'>('primary');
  hideBody = input<boolean>(false);
}
